import type { InjectionKey } from "vue"

export interface IAuthenticationState {
  isAuthenticated(): boolean
  getToken(): string | undefined
  setToken(token?: string): void
}

export class AuthenticationState implements IAuthenticationState {
  private static readonly TOKEN_KEY = "access-token"
  private accessToken: string | undefined

  constructor() {
    this.accessToken = localStorage.getItem(AuthenticationState.TOKEN_KEY) ?? undefined
  }

  isAuthenticated(): boolean {
    return !!this.accessToken
  }
  getToken(): string | undefined {
    return this.accessToken
  }
  setToken(token?: string): void {
    this.accessToken = token

    if (token) {
      localStorage.setItem(AuthenticationState.TOKEN_KEY, token)
    }
    else {
      localStorage.removeItem(AuthenticationState.TOKEN_KEY)
    }
  }
}

export const AUTH_STATE = Symbol() as InjectionKey<IAuthenticationState>
